const WEBVIEW_BRIDGE_PROTOCOL = 'ctjscall://';

export type BridgeMessageType = 'authorize' | 'open' | 'close' | 'share';

export class BridgeMessageBuilder {
  private message = '';

  constructor() {
    this.initialize();
  }

  private initialize = () => {
    this.message = WEBVIEW_BRIDGE_PROTOCOL;
  };

  setType = (type: BridgeMessageType): BridgeMessageBuilder => {
    this.message = this.message.concat(type);
    return this;
  };

  setCallbackKey = (callbackKey: string): BridgeMessageBuilder => {
    this.message = this.message.concat(`?callbackKey=${callbackKey}`);
    return this;
  };

  setUrl = (url: string): BridgeMessageBuilder => {
    this.message = this.message.concat(`?url=${encodeURIComponent(url)}`);
    return this;
  };

  setMessage = (message: string): BridgeMessageBuilder => {
    this.message = this.message.concat(`?message=${message}`);
    return this;
  };

  getBridgeMessage = (): string => {
    const result = this.message;
    this.initialize();
    return result;
  };
}
